import React from "react";
import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import GamePage from "@/pages/GamePage";
import SideloadPage from "@/pages/SideloadPage";
import PrintsPage from "@/pages/PrintsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import LegalPage from "@/pages/LegalPage";
import GameTermsPage from "@/pages/GameTermsPage";

function App() {
  return (
    <BrowserRouter>
      <div className="App relative" data-testid="app-root">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/prints" element={<PrintsPage />} />
            <Route path="/games/:slug" element={<GamePage />} />
            <Route path="/sideload" element={<SideloadPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/legal" element={<LegalPage />} />
            <Route path="/terms" element={<GameTermsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
